import { render } from "./BanksEditor.vue?vue&type=template&id=71c9071c"
import script from "./BanksEditor.vue?vue&type=script&lang=js"
export * from "./BanksEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__